import { useQuery } from "@apollo/client";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import sortBy from "lodash/sortBy";

import { Box } from "@/components/layout/flexbox";
import { Col, Container, Row } from "@/components/pieces/bootstrap";
import FaqItems from "@/components/pieces/faq/FaqItems";
import { BRAND_PURPLE, PUBLIC_CONTENT_MAX_WIDTH } from "@/css/constants";
import { FaqsDocument } from "@/graphql";

export default function Faq() {
  const { loading, data } = useQuery(FaqsDocument, {
    fetchPolicy: "cache-first",
    variables: {
      domain: IS_EXEC ? "exec" : "placement",
    },
  });

  if (loading) {
    return null;
  } else {
    const faqs = sortBy(data.faqs, (c) => c.order);
    return (
      <>
        {faqs.map((faq) => {
          if (!faq) return null;
          const questions = sortBy(faq.questions, (q) => q.order);
          const faqItems = questions.map((item) => {
            return {
              question: item.question,
              answer: documentToHtmlString(JSON.parse(item.answer)),
            };
          });

          return (
            <Container
              maxWidth={PUBLIC_CONTENT_MAX_WIDTH}
              my="4rem"
              key={faq.category}
            >
              <Row>
                <Col width={[1, 1, 1 / 3]}>
                  <Box
                    color={BRAND_PURPLE}
                    fontSize={30}
                    mt="1rem"
                    mb="2rem"
                    fontWeight={500}
                  >
                    {faq.category}
                  </Box>
                </Col>

                <Col width={[1, 1, 2 / 3]}>
                  <div className="collapsible-list">
                    <FaqItems faqItems={faqItems} />
                  </div>
                </Col>
              </Row>
            </Container>
          );
        })}
      </>
    );
  }
}
